<h2 mat-dialog-title>Event #{{ event.appEventId }} — {{ event.eventType }}</h2>
<mat-dialog-content>
  <table class="detail-table">
    <tr><th>When</th><td>{{ event.clickedAt | date:'yyyy-MM-dd HH:mm:ss' }}</td></tr>
    <tr><th>Type</th><td>{{ event.eventType }}</td></tr>
    <tr><th>Category</th><td>{{ event.eventCategory }}</td></tr>
    <tr><th>User</th><td>{{ event.username }} <span class="muted" *ngIf="event.userId">(id {{ event.userId }})</span></td></tr>
    <tr><th>Visitor Id</th><td>{{ event.visitorId || '—' }}</td></tr>
    <tr><th>Session Id</th><td>{{ event.sessionId || '—' }}</td></tr>
    <tr><th>Property Id</th><td>{{ event.propertyId || '—' }}</td></tr>
    <tr><th>Tracked Link Id</th><td>{{ event.trackedLinkId || '—' }}</td></tr>
    <tr><th>Device</th><td>{{ event.deviceType || '—' }}</td></tr>
    <tr><th>Country / Region</th><td>{{ event.country || '—' }} / {{ event.region || '—' }}</td></tr>
    <tr *ngIf="event.searchQuery"><th>Search Query</th><td>{{ event.searchQuery }}</td></tr>
    <tr *ngIf="event.resultCount != null"><th>Results</th><td>{{ event.resultCount }}</td></tr>
    <tr *ngIf="event.responseTimeMs != null"><th>Response Time</th><td>{{ event.responseTimeMs }} ms</td></tr>
    <tr *ngIf="event.amount != null"><th>Amount</th><td>{{ event.amount | currency }}</td></tr>
    <tr><th>Referer</th><td class="wrap">{{ event.referer || '—' }}</td></tr>
    <tr><th>User Agent</th><td class="wrap">{{ event.userAgent || '—' }}</td></tr>
    <tr><th>IP Hash</th><td class="mono">{{ event.ipHash || '—' }}</td></tr>
    <tr *ngIf="prettyMetadata"><th>Metadata</th><td><pre class="json">{{ prettyMetadata }}</pre></td></tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
